export enum ViewAccessReason {
  WRITTEN_REQUEST = 'WRITTEN_REQUEST',
  SUPPORT_REQUEST = 'SUPPORT_REQUEST'
}
